// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Wrapper for the component */
.multi-image-wrapper {
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	flex-flow: row wrap;
	margin-bottom: 1rem;
	padding: 1.5rem 2rem;
	width: auto;
	max-width: 80%;
	border: 2px solid rgb(17, 17, 17);
}

/* Style for the Add Image icon -- START -- */
.multi-image-file-upload {
	cursor: pointer;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin-top: 1.5rem;
	max-width: 10rem;
	border-radius: 12px;
	transition: 0.3s ease-in-out;
}

.multi-image-file-upload:hover {
	transform: scale(1.12);
	transition: 0.3s ease;
	color: rgba(12, 65, 96, 0.7);
	fill: rgba(12, 65, 96, 0.7);
}

.multi-image-file-upload input {
	visibility: hidden;
}

.multi-image-file-upload span {
	font-size: 0.672em;
}
/* Style for the Add Image icon -- END -- */

/* Container to hold uploaded images -- START -- */
.multi-image-container {
	cursor: pointer;
	position: relative;
	display: inline-block;
	width: 200px;
	height: 135px;
}

.multi-image-container img {
	width: 100%;
	height: 100%;
	border-radius: 8px;
	padding: 0.225rem;
	transition: 0.3s ease-in-out;
}

.multi-image-container img:hover {
	transform: scale(0.93);
	transition: 0.3s ease;
}
/* Container to hold uploaded images -- END -- */

/* Delete icon on uploaded image -- START -- */
.multi-image-delete:hover::after {
	background: rgba(202, 6, 6, 0.9);
}

.multi-image-delete::after {
	content: "x";
	position: absolute;
	right: 10px;
	top: 10px;
	width: 20px;
	height: 20px;
	text-align: center;
	background: rgba(202, 6, 6, 0.6);
	border-radius: 50%;
	display: block;
	color: white;
}
/* Delete icon on uploaded image -- END -- */

/* Uncropped image warning icon -- START -- */
.multi-image-uncropped {
	position: absolute;
	top: 50%;
	left: 50%;
	font-size: 5em;
	transform: translate(-50%, -50%);
	color: rgba(255, 255, 255, 0.6);
	z-index: 10;
}

.multi-image-uncropped:hover {
	color: rgba(255, 255, 255, 0.8);
}
/* Uncropped image warning icon -- END -- */

/* Error message styles -- START --*/
.multi-image-errors {
	cursor: default;
	display: flex;
	align-content: flex-start;
	justify-content: flex-start;
	align-items: flex-start;
	flex-direction: column;
}

.multi-image-error-title {
	margin-top: 3rem;
	font-weight: 600;
	font-size: 1.125em;
}

.multi-image-error-message {
	font-size: 1.025em;
}

.multi-image-error-message li {
	line-height: 1.7rem;
}
/* Error message styles -- END --*/

/* Other styles -- START -- */
.multi-image-bold-text {
	font-weight: bold;
}

.multi-image-upload-button {
	border-width: 2px;
	font-weight: 600;
	font-size: 0.85em;
	line-height: 1.6em;
	text-transform: uppercase;
	border: none;
	margin: 6px 1px;
	border-radius: 3px;
	margin-top: 3.25rem;
	padding: 11px 22px;
	cursor: pointer;
	white-space: nowrap;
	background: rgb(12, 65, 96);
	color: #ffffff;
	transition: all 150ms linear;
}

.multi-image-upload-button:hover {
	transform: scale(1.02);
	transition: 0.3s ease;
	background: rgba(12, 65, 96, 0.9);
}
/* Other styles -- END -- */

/*.multi-image-selected::after {
	content: "✔";
	position: absolute;
	right: 14px;
	top: 14px;
	width: 20px;
	height: 20px;
	text-align: center;
	background: #65c8e6;
	border-radius: 50%;
	display: block;
	color: white;
}

.multi-image-unselected {
	display: none;
} */

/* .multi-image-scale {
	/* -webkit-transform: scale(0.93);
	-ms-transform: scale(0.93);
	transform: scale(0.93); */
/* box-shadow: 0 2px 15px #acacac; */
/* border: 3px solid #65c8e6; */
`, "",{"version":3,"sources":["webpack://./src/assets/css/multi-image.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;CACC,aAAa;CACb,uBAAuB;CACvB,2BAA2B;CAC3B,mBAAmB;CACnB,mBAAmB;CACnB,oBAAoB;CACpB,WAAW;CACX,cAAc;CACd,iCAAiC;AAClC;;AAEA,6CAA6C;AAC7C;CACC,eAAe;CACf,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;CACvB,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;CACnB,4BAA4B;AAC7B;;AAEA;CAGC,sBAAsB;CACtB,qBAAqB;CACrB,4BAA4B;CAC5B,2BAA2B;AAC5B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;AACA,2CAA2C;;AAE3C,kDAAkD;AAClD;CACC,eAAe;CACf,kBAAkB;CAClB,qBAAqB;CACrB,YAAY;CACZ,aAAa;AACd;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,iBAAiB;CACjB,4BAA4B;AAC7B;;AAEA;CAGC,sBAAsB;CACtB,qBAAqB;AACtB;AACA,gDAAgD;;AAEhD,8CAA8C;AAC9C;CACC,gCAAgC;AACjC;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,WAAW;CACX,SAAS;CACT,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,gCAAgC;CAChC,kBAAkB;CAClB,cAAc;CACd,YAAY;AACb;AACA,4CAA4C;;AAE5C,6CAA6C;AAC7C;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,cAAc;CACd,gCAAgC;CAChC,+BAA+B;CAC/B,WAAW;AACZ;;AAEA;CACC,+BAA+B;AAChC;AACA,2CAA2C;;AAE3C,oCAAoC;AACpC;CACC,eAAe;CACf,aAAa;CACb,yBAAyB;CACzB,2BAA2B;CAC3B,uBAAuB;CACvB,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB;AACA,kCAAkC;;AAElC,6BAA6B;AAC7B;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;CAClB,yBAAyB;CACzB,YAAY;CACZ,eAAe;CACf,kBAAkB;CAClB,mBAAmB;CACnB,kBAAkB;CAClB,eAAe;CACf,mBAAmB;CACnB,2BAA2B;CAC3B,cAAc;CACd,4BAA4B;AAC7B;;AAEA;CAGC,sBAAsB;CACtB,qBAAqB;CACrB,iCAAiC;AAClC;AACA,2BAA2B;;AAE3B;;;;;;;;;;;;;;;;GAgBG;;AAEH;;;0BAG0B;AAC1B,oCAAoC;AACpC,+BAA+B","sourcesContent":["/* Wrapper for the component */\n.multi-image-wrapper {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\tflex-flow: row wrap;\n\tmargin-bottom: 1rem;\n\tpadding: 1.5rem 2rem;\n\twidth: auto;\n\tmax-width: 80%;\n\tborder: 2px solid rgb(17, 17, 17);\n}\n\n/* Style for the Add Image icon -- START -- */\n.multi-image-file-upload {\n\tcursor: pointer;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tmargin-top: 1.5rem;\n\tmax-width: 10rem;\n\tborder-radius: 12px;\n\ttransition: 0.3s ease-in-out;\n}\n\n.multi-image-file-upload:hover {\n\t-webkit-transform: scale(1.12);\n\t-ms-transform: scale(1.12);\n\ttransform: scale(1.12);\n\ttransition: 0.3s ease;\n\tcolor: rgba(12, 65, 96, 0.7);\n\tfill: rgba(12, 65, 96, 0.7);\n}\n\n.multi-image-file-upload input {\n\tvisibility: hidden;\n}\n\n.multi-image-file-upload span {\n\tfont-size: 0.672em;\n}\n/* Style for the Add Image icon -- END -- */\n\n/* Container to hold uploaded images -- START -- */\n.multi-image-container {\n\tcursor: pointer;\n\tposition: relative;\n\tdisplay: inline-block;\n\twidth: 200px;\n\theight: 135px;\n}\n\n.multi-image-container img {\n\twidth: 100%;\n\theight: 100%;\n\tborder-radius: 8px;\n\tpadding: 0.225rem;\n\ttransition: 0.3s ease-in-out;\n}\n\n.multi-image-container img:hover {\n\t-webkit-transform: scale(0.93);\n\t-ms-transform: scale(0.93);\n\ttransform: scale(0.93);\n\ttransition: 0.3s ease;\n}\n/* Container to hold uploaded images -- END -- */\n\n/* Delete icon on uploaded image -- START -- */\n.multi-image-delete:hover::after {\n\tbackground: rgba(202, 6, 6, 0.9);\n}\n\n.multi-image-delete::after {\n\tcontent: \"x\";\n\tposition: absolute;\n\tright: 10px;\n\ttop: 10px;\n\twidth: 20px;\n\theight: 20px;\n\ttext-align: center;\n\tbackground: rgba(202, 6, 6, 0.6);\n\tborder-radius: 50%;\n\tdisplay: block;\n\tcolor: white;\n}\n/* Delete icon on uploaded image -- END -- */\n\n/* Uncropped image warning icon -- START -- */\n.multi-image-uncropped {\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\tfont-size: 5em;\n\ttransform: translate(-50%, -50%);\n\tcolor: rgba(255, 255, 255, 0.6);\n\tz-index: 10;\n}\n\n.multi-image-uncropped:hover {\n\tcolor: rgba(255, 255, 255, 0.8);\n}\n/* Uncropped image warning icon -- END -- */\n\n/* Error message styles -- START --*/\n.multi-image-errors {\n\tcursor: default;\n\tdisplay: flex;\n\talign-content: flex-start;\n\tjustify-content: flex-start;\n\talign-items: flex-start;\n\tflex-direction: column;\n}\n\n.multi-image-error-title {\n\tmargin-top: 3rem;\n\tfont-weight: 600;\n\tfont-size: 1.125em;\n}\n\n.multi-image-error-message {\n\tfont-size: 1.025em;\n}\n\n.multi-image-error-message li {\n\tline-height: 1.7rem;\n}\n/* Error message styles -- END --*/\n\n/* Other styles -- START -- */\n.multi-image-bold-text {\n\tfont-weight: bold;\n}\n\n.multi-image-upload-button {\n\tborder-width: 2px;\n\tfont-weight: 600;\n\tfont-size: 0.85em;\n\tline-height: 1.6em;\n\ttext-transform: uppercase;\n\tborder: none;\n\tmargin: 6px 1px;\n\tborder-radius: 3px;\n\tmargin-top: 3.25rem;\n\tpadding: 11px 22px;\n\tcursor: pointer;\n\twhite-space: nowrap;\n\tbackground: rgb(12, 65, 96);\n\tcolor: #ffffff;\n\ttransition: all 150ms linear;\n}\n\n.multi-image-upload-button:hover {\n\t-webkit-transform: scale(1.02);\n\t-ms-transform: scale(1.02);\n\ttransform: scale(1.02);\n\ttransition: 0.3s ease;\n\tbackground: rgba(12, 65, 96, 0.9);\n}\n/* Other styles -- END -- */\n\n/*.multi-image-selected::after {\n\tcontent: \"✔\";\n\tposition: absolute;\n\tright: 14px;\n\ttop: 14px;\n\twidth: 20px;\n\theight: 20px;\n\ttext-align: center;\n\tbackground: #65c8e6;\n\tborder-radius: 50%;\n\tdisplay: block;\n\tcolor: white;\n}\n\n.multi-image-unselected {\n\tdisplay: none;\n} */\n\n/* .multi-image-scale {\n\t/* -webkit-transform: scale(0.93);\n\t-ms-transform: scale(0.93);\n\ttransform: scale(0.93); */\n/* box-shadow: 0 2px 15px #acacac; */\n/* border: 3px solid #65c8e6; */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
